import { render } from "./Booking.vue?vue&type=template&id=0485dfc0&scoped=true"
import script from "./Booking.vue?vue&type=script&lang=js"
export * from "./Booking.vue?vue&type=script&lang=js"

import "../assets/css/booking.css?vue&type=style&index=0&id=0485dfc0&scoped=true&lang=css&external"
import "./Booking.vue?vue&type=style&index=1&id=0485dfc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0485dfc0"]])

export default __exports__